


















































































































































// @ is an alias to /src
import Vue from "vue";
import { RouteRepo, IRoute } from "../libs/RouteRepository";

export default Vue.extend({
  name: "Home",
  components: {},
  data() {
    return {
      userInput: {
        code: "",
      },
      purchase: {
        firstName: "",
        lastName: "",
        company: "",
        street: "",
        number: "",
        city: "",
        postalCode: "",
        vat: "",
        email: "",
        confirmEmail: "",
      },
      acceptConditions: false,
      routeId: this.$route.params["id"],
      errors: [] as string[],
      viewMode: "overview",
      route: undefined as IRoute | undefined,
    };
  },
  methods: {
    async validate() {
      this.errors = [];

      if (this.userInput.code == "") {
        this.errors.push("code-empty");
      }

      if (this.errors.length !== 0) {
        return;
      }

      this.errors = await RouteRepo.unlockRoute(
        this.userInput.code,
        this.routeId
      );

      if (this.errors.length === 0) {
        localStorage.setItem(this.routeId, this.userInput.code);
        this.$router.push("/route/" + this.routeId);
      }
    },
    async purchaseRoute() {
      this.errors = [];

      if (this.purchase.firstName == "") {
        this.errors.push("firstName");
      }

      if (!this.acceptConditions) {
        this.errors.push("acceptConditions");
      }

      if (this.purchase.lastName == "") {
        this.errors.push("lastName");
      }

      if (this.purchase.street == "") {
        this.errors.push("street");
      }

      if (this.purchase.number == "") {
        this.errors.push("number");
      }

      if (this.purchase.city == "") {
        this.errors.push("city");
      }

      if (this.purchase.postalCode == "") {
        this.errors.push("postalCode");
      }

      if (this.purchase.email == "") {
        this.errors.push("email");
      }

      if (this.purchase.email.trim() != this.purchase.confirmEmail.trim()) {
        this.errors.push("confirmEmail");
      }

      if (this.errors.length !== 0) {
        return;
      }

      var result = await RouteRepo.purchaseRoute(
        this.purchase.firstName,
        this.purchase.lastName,
        this.purchase.company,
        this.purchase.street,
        this.purchase.number,
        this.purchase.city,
        this.purchase.postalCode,
        this.purchase.vat,
        this.purchase.email,
        this.routeId
      );

      console.log(result);
      console.log("result");

      if (result === undefined) {
        this.errors.push("error");
      }
      if (this.errors.length === 0) {
        if (result !== undefined) {
          window.location.href = result.paymentUrl;
        }
      }
    },
    setViewMode(mode: string) {
      this.viewMode = mode;
    },
  },
  mounted: async function () {
    this.route = await RouteRepo.getRouteById(this.routeId);
    console.log("route");
    console.log(this.route);
    var existingCode = localStorage.getItem(this.routeId);
    if (existingCode !== null) {
      this.errors = await RouteRepo.unlockRoute(existingCode, this.routeId);

      if (this.errors.length === 0) {
        this.$router.push("/route/" + this.routeId);
      }
      this.errors = [];
    }
  },
  watch: {},
  computed: {},
});
